// extracted by mini-css-extract-plugin
export default {"title":"PageHeader_title__ZuVtl","subtitle":"PageHeader_subtitle__UlHpF"};